import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material";
import { addDoc, collection, doc, updateDoc } from "firebase/firestore";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { db } from "../../api/firebase";
import { nbfRawMetarial, nbfRecipe } from "../../api/restApi";
import { recipeData, setRecipe } from "../../store/reducer/recipeSlice";
import { useAppDispatch, useAppSelector } from "../../utils/hooks";
import RecipeTable from "./Tables/RecipeTable";

const Recipe = () => {
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [itemCategory, setItemCategory] = useState("");
  const { recipe } = useAppSelector(recipeData);
  const dispatch = useAppDispatch();
  const collectionName = "Recipe";

  const RecipeInfo = async () => {
    let recipe = await nbfRecipe();
    dispatch(setRecipe(recipe));
  };

  useEffect(() => {
    RecipeInfo();
  });

  const handleItem = async () => {
    const data= await nbfRecipe();
    console.log(data)
    let items = await nbfRawMetarial();
    console.log(items)
    const addItemArray = items.map((item) => item.addItem);
    setItemCategory([...addItemArray]);

  };

  useEffect(() => {
    const fetchData = async () => {
      await handleItem();
    };

    if (createModalOpen) {
      fetchData();
    }
  }, [createModalOpen]);

  const handleCreateNewRow = async (values) => {
    try {
      if (!values || Object.keys(values).length === 0) {
        alert("Please enter valid data");
        return;
      }
      await addDoc(collection(db, collectionName), values);
      toast.success("Successfully add new item !", {
        position: toast.POSITION.BOTTOM_CENTER,
      });

      RecipeInfo();
    } catch (error) {
      console.log(error);
      toast.error("Failed to add new item !", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  const handleSaveRowEdits = async ({ exitEditingMode, row, values }) => {
    try {
      let id = row.getValue("id").toString();
      await updateDoc(doc(db, collectionName, id), values);

      toast.success("Successfully update  item !", {
        position: toast.POSITION.BOTTOM_CENTER,
      });

      RecipeInfo();
    } catch (error) {
      // console.log(error);
      toast.error("Failed to  update  item!", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
    exitEditingMode(); //required to exit editing mode and close modal
    // }
  };

  const columns = useMemo(() => [
    {
      accessorKey: "id",
      header: "ID",
      enableColumnOrdering: false,
      enableEditing: false, //disable editing on this column
      enableSorting: false,
      size: 80,
    },
    {
      accessorKey: "recipe_Name",
      header: "Recipe Name",
      size: 140,
    },
    {
      accessorKey: "category",
      header: "Category",
      size: 140,
    },
    {
      accessorKey: "unit_size",
      header: "Unit Size",
      size: 140,
    },
    {
      accessorKey: "unit",
      header: "Unit",
      size: 140,
    },
    {
      accessorKey: "itemsArray",
      header: "Items Used",
      size: 140,
      // Render itemsArray as a custom cell component
      Cell: ({ value }) => (
        <div>
          {Array.isArray(value) ? (
            value.map((item, index) => (
              <div key={index}>
                {item.quantity} {item.unit} of {item.itemCategory}
              </div>
            ))
          ) : (
            "No items"
          )}
        </div>
      ),
    },
    // {
    //   accessorKey: "quantity",
    //   header: "Quantity",
    //   size: 140,
    // },
  ]);

  return (
    <>
      <Stack spacing={4} marginX={4} mt={1}>
        <RecipeTable
          setCreateModalOpen={setCreateModalOpen}
          tableData={recipe}
          handleSaveRowEdits={handleSaveRowEdits}
          //   handleCancelRowEdits={handleCancelRowEdits}
          //   handleDeleteRow={handleDeleteRow}
          columns={columns}
          csvFileName="recipe"
        ></RecipeTable>
      </Stack>
      <CreateNewAccountModal
        columns={columns}
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSubmit={handleCreateNewRow}
        itemCategory={itemCategory}
      />
    </>
  );
};

//example of creating a mui dialog modal for creating new rows
export const CreateNewAccountModal = ({
  open,
  columns,
  onClose,
  onSubmit,
  itemCategory,
}) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [itemsArray, setItemsArray] = useState([]);
  const [values, setValues] = useState({});

  const itemQuantity = useRef(null);

  const handleSubmit = async () => {
    onSubmit(values);
    onClose();
    setValues({});
  };
  const unitOptions = ["kg", "ltr", "packet", "piecs"];
  const category = ["a", "b", "c", "d"];

  const handleItemChange = (event, newValue) => {
    setSelectedItem(newValue);
  };

  const handleAddItem = () => {
    if (selectedItem && itemQuantity.current.value !== "") {
      const newItem = {
        itemCategory: selectedItem,
        quantity: parseInt(itemQuantity.current.value),
      };

      setItemsArray([...itemsArray, newItem]);
      setSelectedItem(null);
      itemQuantity.current.value = null;
    }
  };

  useEffect(() => {
    setValues({ ...values, itemsArray });
  }, [itemsArray]);

  useEffect(() => {
    console.log(values);
  }, [values]);

  return (
    <Dialog open={open}>
      <DialogTitle textAlign="center">Add Items</DialogTitle>
      <DialogContent>
        <form onSubmit={(e) => e.preventDefault()}>
          <Stack
            sx={{
              width: "100%",
              minWidth: { xs: "350px", sm: "500px", md: "400px" },
              gap: "1.5rem",
            }}
          >
            <Box>
              <label>Recipe Name</label>
              <TextField
                type="text"
                sx={{ minWidth: "100%" }}
                value={values.recipe_Name}
                onChange={(e) =>
                  setValues({ ...values, recipe_Name: e.target.value })
                }
              />
            </Box>
            <Box>
              <label>Category</label>
              <Autocomplete
                disablePortal
                id="combo-box-demo3"
                options={category}
                sx={{
                  minWidth: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
                renderInput={(params) => <TextField {...params} />}
                value={values.category}
                onChange={(event, newValue) =>
                  setValues({ ...values, category: newValue })
                }
              />
            </Box>
            <Box>
              <label>Unit Size</label>
              <TextField
                type="number"
                sx={{ minWidth: "100%" }}
                value={values.unit_size}
                onChange={(e) =>
                  setValues({ ...values, unit_size: e.target.value })
                }
              />
            </Box>
            <Box>
              <label>Unit</label>
              <Autocomplete
                disablePortal
                id="combo-box-demo3"
                options={unitOptions}
                sx={{
                  minWidth: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
                renderInput={(params) => <TextField {...params} />}
                value={values.unit}
                onChange={(event, newValue) =>
                  setValues({ ...values, unit: newValue })
                }
              />
            </Box>

            <div style={{ display: "flex", alignItems: "center" }}>
              <Box>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo4"
                  sx={{ width: "150px", marginRight: "1rem" }}
                  options={itemCategory}
                  getOptionLabel={(option) => option}
                  value={selectedItem}
                  onChange={handleItemChange}
                  renderInput={(params) => (
                    <TextField {...params} label="Item Category" />
                  )}
                />
              </Box>
              <Box>
                <TextField
                  label="Quantity"
                  type="number"
                  sx={{ width: "150px" }}
                  inputRef={itemQuantity}
                />
              </Box>
              <Button onClick={handleAddItem}>Add</Button>
            </div>

            <div style={{ display: "flex", justifyContent: "center" }}>
              {itemsArray.map((item, index) => (
                <span key={index}>
                  {item.itemCategory}
                  {","}
                </span>
              ))}
            </div>
          </Stack>
        </form>
      </DialogContent>
      <DialogActions sx={{ p: "1.25rem" }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button color="secondary" onClick={handleSubmit} variant="contained">
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Recipe;
